module.exports = __webpack_public_path__ + "static/media/pause.860045c4.svg";